import { render } from "./SuccesView.vue?vue&type=template&id=fbd928d8&scoped=true"
import script from "./SuccesView.vue?vue&type=script&lang=js"
export * from "./SuccesView.vue?vue&type=script&lang=js"

import "./SuccesView.vue?vue&type=style&index=0&id=fbd928d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd928d8"]])

export default __exports__